import React, { forwardRef } from 'react';
import c from 'classnames';

import Box from '../Box';
import { TouchableProps } from './types';

const Touchable = forwardRef<HTMLDivElement, TouchableProps>((props, ref) => {
  const { children, className, onClick, ...restProps } = props;

  return (
    <Box
      ref={ref}
      className={c('focus:outline-none', className)}
      role="button"
      tabIndex={0}
      onClick={onClick as any}
      {...restProps}>
      {children}
    </Box>
  );
});

export default Touchable;
